const exportQueryKeys = {
  exportRequests: (filter) => {
    if (!filter || Object.keys(filter).length === 0) {
      return [
        "data-exports",
        null
      ];
    }
    return [
      "data-exports",
      filter
    ];
  }
};

export { exportQueryKeys };
//# sourceMappingURL=exportQueryKeys.js.map
